<div class="card">
  <div class="card-header">
    {{ 'REGISTER.AWAITING_APPROVAL' | translate }}
  </div>
  <div class="card-block">
    <p>{{ 'REGISTER.THANKS_WAITING_FOR_APPROVAL' | translate }}</p>
  </div>
</div>
